// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"News_swiper-slide-active__GxID3","news":"News_news__fxOBv"};